<template>
  <div
    data-aos="zoom-in"
    data-aos-duration="600"
    :data-aos-delay="200 * index"
    class="price-card"
    :class="classObject"
  >
    <div class="icon-wrap">
      <img :src="require(`@/assets/icons/${item.icon}`)" alt="steps" />
    </div>
    <div class="text-content">
      <div class="card-title">
        {{ item.type }}
      </div>
      <div class="card-description">
        {{ item.caption }}
      </div>
    </div>
    <div class="card-features">
      <div
        class="feature"
        :key="index"
        v-for="(feature, index) in item.features"
      >
        <div class="icon-wrap">
          <img src="@/assets/icons/price-tick.svg" style="width:20px !important; max-width:17px !important;" alt="steps" />
        </div>
        <div class="feature-info">
          {{ feature }}
        </div>
      </div>
    </div>
    <div
      class="price-list"
      v-if="item.pricelist && item.pricelist.length === 1"
    >
      <div class="price-info">Free</div>
    </div>
    <div class="price-list" v-else>
      <div
        class="price-info"
        :key="index"
        v-for="(price, index) in item.pricelist"
      >
        ${{ price }}
        <span v-if="index === 0">/mo</span>
        <span v-if="index === 1">/6mo</span>
        <span v-if="index === 2">/yr</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceCard",
  props: {
    item: {
      type: [Object, Array]
    },
    index: {
      type: Number
    },
    extraClass: {
      type: [String, Array]
    }
  },
  computed: {
    classObject() {
      return this.extraClass ? this.extraClass : "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.price-card {
  background: #ffffff;
  padding: 40px 30px;
  @include boxShadow(1px, 1px, 40px, 0px, rgba(0, 0, 0, 0.05));
  transition: all 0.3s ease-in-out;
  > .icon-wrap {
    margin: 0 auto 15px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    @include boxShadow(1px, 1px, 10px, 0px, rgba(33, 33, 100, 0.16));
    img {
      width: 25px;
    }
  }
  .text-content {
    text-align: center;
    font-family: $content-font;
    .card-title {
      font-size: 22px;
      color: #212164;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .card-description {
      font-size: 15px;
      line-height: 25px;
      color: #707070;
    }
  }
  .card-features {
    margin-top: 30px;
    .feature {
      display: flex;
      justify-content: flex-start;
      padding-bottom: 15px;
      .icon-wrap {
        width: 18px;
        margin-right: 15px;
      }
      .feature-info {
        font-family: $content-font;
        font-size: 15px;
        font-weight: 500;
        line-height: 20px;
        color: #525252;
      }
      &:last-child {
        padding-bottom: 0;
      }
    }
  }
  .price-list {
    display: flex;
    justify-content: center;
    .price-info {
      margin-top: 30px;
      text-align: center;
      font-family: $content-font;
      font-size: 22px;
      font-weight: 700;
      color: #b4262d;
      margin-right: 15px;
      span {
        font-size: 12px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &:hover {
    transform: translateY(-5px);
    @include boxShadow(0, 13px, 25px, 8px, rgba(0, 0, 0, 0.1));
  }
  &.no-list {
    .card-features {
      display: none;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .price-card {
    .text-content {
      .card-description {
        font-size: 14px;
        line-height: 22px;
      }
    }
    .card-features {
      .feature {
        .feature-info {
          font-size: 14px;
        }
      }
    }
    .price-list {
      .price-info {
        font-size: 20px;
      }
    }
  }
}

@media only screen and (max-width: 425px) {
  .price-card {
    padding: 30px 15px;
    .text-content {
      .card-description {
        font-size: 14px;
        line-height: 22px;
      }
    }
    .card-features {
      .feature {
        .feature-info {
          font-size: 14px;
        }
      }
    }
    .price-list {
      .price-info {
        font-size: 20px;
      }
    }
  }
}
</style>
